import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { PortalContext } from "_+_Portal/context/Provider";
import {
  wsGetMercadoPago,
  wsGetMercadoPagoReferencia,
} from "_+_Portal/context/Actions/mercadoPago/mercadoPago";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import CardBlueHeart from "_+_Portal/_-_Autocheckin/components/genericos/CardBlueHeart/CardBlueHeart";
import PasoBar from "_+_Portal/_-_Autocheckin/components/genericos/PasoBar/PasoBar";
import MercadoPagoLogo from "_+_Portal/assets/images/generico/MercadoPagoLogo";
import TildeOk from "_+_Portal/assets/images/generico/TildeOk";
import {
  BtnVolver,
  Container,
  Header,
  LoadingDots,
  QrContainer,
  SuccessOverlay,
  TildeWrapper,
  Total,
} from "./localStyle";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { mercadoPagoReset } from "_+_Portal/context/Actions/mercadoPago/mercadoPago";
import { proximoPaso } from "../PagesFun";
import { setRuta } from "_+_Portal/_-_Autocheckin/context/action/ruta";
import { setIdTipoPuntoControl } from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import { getLocalStorage } from "global/utils/safeJsonParse";

// Pantalla de QR: muestra imagen QR y hace polling hasta confirmar pago
const MercadoPagoQRDesktop = () => {
  const history = useHistory();
  const {
    turnosSeleccionadosState,
    pasoDispatch,
    rutaState,
    pasoState,
    rutaDispatch,
    puntoControlDispatch,
  } = useContext(AutocheckContext);
  const { mercadoPagoDispatch, mercadoPagoState } = useContext(PortalContext);

  const [loading, setLoading] = useState(true);
  const [referenciaExterna, setReferenciaExterna] = useState(null);
  const [pagoAprobado, setPagoAprobado] = useState(false);
  const dataMP = mercadoPagoState?.mercadoPago?.data;
  const actual = rutaState?.ruta?.data?.actual ?? 0;
  const turnosSel = turnosSeleccionadosState?.turnosSeleccionados?.data || [];
  const turno = turnosSel[actual] || {};
  let idTerminal = getLocalStorage("idTerminal");
  let ruta = rutaState.ruta.data;

  // Efecto para obtener el QR inicial
  useEffect(() => {
    // En labo, turno.idturno trae el id de la agenda de laboratorio (LAB_*), NO un id
    // de MAESTRO_TURNOS. Hay que mandar idTurno=0 para que el backend tome la rama de
    // protocolo; si se manda el id real, lo intenta validar como turno médico y falla.
    const esLabo = turno?.idProtocolo > 0;
    wsGetMercadoPago(
      esLabo ? 0 : turno.idturno,
      turno.idProtocolo ?? 0,
      nextStepMP,
    )(mercadoPagoDispatch);
  }, []);

  // Callback del primer GET - guarda la referencia externa para iniciar el polling
  const nextStepMP = (isCorrect, data) => {
    if (isCorrect && data?.referenciaExterna) {
      setLoading(false);
      setReferenciaExterna(data.referenciaExterna);
    } else {
      setLoading(false);
      irPuntoDeControl();
    }
  };

  const irPuntoDeControl = () => {
    setLoading(true);
    const idTipoPuntoControl = 8;
    setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
    setPaso("PuntoControl")(pasoDispatch);
  };

  const volver = () => {
    setPaso("AbonarMP")(pasoDispatch);
  };

  // Efecto para el loop de polling - verifica si el pago fue realizado cada 15 segundos
  useEffect(() => {
    if (!referenciaExterna) return;

    let idLoop = null;

    // Función que verifica el estado del pago
    const checkPayment = () => {
      wsGetMercadoPagoReferencia(referenciaExterna, (isCorrect, data) => {
        const dataMp = data?.content && JSON.parse(data?.content);
        if (dataMp) {
          const condition =
            dataMp.id !== 0 &&
            dataMp.external_reference &&
            dataMp.status === "approved";
          if (isCorrect && condition) {
            // Pago confirmado, detiene el loop y dispara animación de éxito
            clearInterval(idLoop);
            setPagoAprobado(true);
            // Esperar a que termine la animación (~2s) antes de avanzar al siguiente paso
            setTimeout(() => {
              // El circuito de labo nunca arma la `ruta` (navega paso a paso con
              // setPaso), así que proximoPaso() sacaría undefined de un array vacío
              // y dejaría la app en una pantalla inexistente. En labo el cierre lo
              // hace CierreRecepcionLabo, que asigna el presente del protocolo.
              if (pasoState.circuito === "labo") {
                setPaso("CierreRecepcionLabo")(pasoDispatch);
              } else {
                setRuta(proximoPaso(ruta, setPaso, pasoDispatch))(rutaDispatch);
              }
            }, 2000);
          }
        }
      })(mercadoPagoDispatch);
    };

    // Primera verificación inmediata
    checkPayment();

    // Luego verifica cada 15 segundos
    idLoop = setInterval(checkPayment, 15000);

    // Cleanup: limpia el interval al desmontar
    return () => {
      if (idLoop) clearInterval(idLoop);
    };
  }, [referenciaExterna]);

  return (
    <>
      <Loading
        dataLoading={loading}
        color="c-white"
        descripcion="Generando código QR..."
      />
      <LayoutPasos
        handleClick={() => {
          mercadoPagoReset()(mercadoPagoDispatch);
          history.push("/autocheckin");
          if (pasoState.circuito === "labo") {
            setPaso("TurnosDelDiaLabo")(pasoDispatch);
          } else {
            setPaso("TurnosDelDia")(pasoDispatch);
          }
        }}
        type={"no-circle"}
        title={"Abonar MP"}
      >
        <Container>
          <Header>
            <CardBlueHeart
              medico={turno?.medico ? turno?.medico : turno?.especialidad}
              turnoTitle={turno?.especialidad}
              pasoActual={actual + 1}
              pasoTotal={
                turnosSeleccionadosState.turnosSeleccionados?.data?.length ?? 0
              }
            />
            <PasoBar paso={"AbonarMP"} />
          </Header>
          <span className={idTerminal ? "rb32m" : "rb18m"}>
            Escanee el QR para abonar mediante Mercadopago
          </span>

          <QrContainer>
            {dataMP?.qr && (
              <img
                className="mercadoPago-img-QR"
                src={`data:image/jpeg;base64,${dataMP.qr}`}
                alt="QR de Mercadopago"
              />
            )}
            <div className="mercadoPago-right">
              <MercadoPagoLogo />
              <LoadingDots>
                <span />
                <span />
                <span />
              </LoadingDots>
            </div>
          </QrContainer>
          <Total>
            <span className={idTerminal ? "rb24m" : "rb18m"}>
              Total a abonar:
            </span>
            <span className="rb36m">
              ${turno?.resumen?.monto ?? turno?.monto ?? 0}
            </span>
          </Total>
          <BtnVolver className="btn bgc-white c-latex30 rb16m" onClick={volver}>
            Volver
          </BtnVolver>
        </Container>
      </LayoutPasos>
      {pagoAprobado && (
        <SuccessOverlay>
          <TildeWrapper>
            <TildeOk color="var(--color-white)" />
          </TildeWrapper>
        </SuccessOverlay>
      )}
    </>
  );
};

export default MercadoPagoQRDesktop;
